import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    common: {
      black: "#000000",
      white: "#ffffff",
    },
    primary: {
      light: "#4d676e",
      main: "#658790",
    },
    secondary: {
      light: "#00a6b6",
      main: "#002759",
    },
    gray: {
      light: "#abb2b2",
      main: "#707575",
    },
    red: {
      main: "#f44336",
      dark: "#d32f2f",
    },
  },
});
